import axios from "axios";
import RightWrapper from "../../../Components/CommonComponents/ComponentWrapper";
import { END_POINT, getJwtToken } from "../../../Redux/AdminReducer/action";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomInput from "../../../Components/CommonComponents/CustomInput";
import CustomTextarea from "../../../Components/CommonComponents/CustomTextarea";
import { useCheckRole } from "../../../UtilityHookFunctions/LoggedInUser";
import { FiArrowLeft } from "react-icons/fi";
import CustomSpinner from "../../../Components/CommonComponents/CustomSpinner";
import TherapyRequestDetails, { OriginBadge, StatusBadge } from "./TherapyRequestDetails";

const fetchItems = async (path) => {
  try {
    const result = await axios.get(`${END_POINT}/${path}`, {
      headers: {
              Authorization: getJwtToken(),
            },
    });
    return result;
  } catch (error) {
    toast.error(error?.response?.data || "Something went wrong");
    console.log(error);

    toast.error("Something went wrong while fetching data");
  }
};

const createItem = async (data, navigate, setIsPorcessing, thid) => {
  try {
    const result = await axios.patch(`${END_POINT}/alternative_therapy/approve/${thid}`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    setIsPorcessing(false);
    navigate(`/AlternativeTherapies`);
    toast.success("Request opened for bidding");
  } catch (error) {
    toast.error(error?.response?.data?.error || "Something went wrong");
    setIsPorcessing(false);
  }
};


const AlternativeTherapies = () => {
  const nav = useNavigate();
  const [formData, setFormData] = useState();
  const { therapy_id } = useParams();
  const [inputdata, setinputdata] = useState({});
  const [isProcessing, setIsPorcessing] = useState(false);
  const checkrole = useCheckRole()

  useEffect(() => {
    fetchItems(`alternative_therapy/getForm/${therapy_id}`).then((e) => {
      setFormData(e?.data);
    });
  }, [therapy_id]);

  const submit_therapy = async () => {
    await createItem(inputdata, nav, setIsPorcessing, therapy_id);
  };

  const canOpenForBidding = checkrole('maindoctor') && formData?.status === 'requested';

  return (
    <RightWrapper>
      <div className="w-full px-2 py-4 md:px-4">
        {/* Page header */}
        <div className="mb-6 flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={() => nav(-1)}
            aria-label="Go back"
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:bg-slate-100 hover:text-slate-900"
          >
            <FiArrowLeft className="h-4 w-4" />
          </button>
          <div className="min-w-0">
            <h1 className="truncate text-xl font-semibold tracking-tight text-slate-900">Therapy Request</h1>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
              <span className="capitalize">Type: {formData?.therapy || '—'}</span>
              <StatusBadge status={formData?.status} />
              <OriginBadge origin={formData?.origin} />
            </div>
          </div>
        </div>

        {formData ? (
          <div className="space-y-6">
            <TherapyRequestDetails requestForm={formData?.requestForm} />

            {canOpenForBidding && (
              <section className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-200 px-6 py-4">
                  <h2 className="text-sm font-semibold tracking-tight text-slate-900">Open for Bidding</h2>
                  <p className="mt-0.5 text-xs text-slate-500">
                    Set the expected duration and a note for consultants before publishing this request.
                  </p>
                </div>

                <div className="px-6 py-5">
                  <div className="max-w-md">
                    <CustomInput
                      type={"text"}
                      name="Duration"
                      label={"Expected Duration (days)"}
                      value={inputdata?.duration || ''}
                      onChange={(i) => {
                        setinputdata((prev) => ({ ...prev, duration: i.target.value }));
                      }}
                      placeholder={"e.g. 30"}
                    />
                    <CustomTextarea
                      type={"text"}
                      name="Note"
                      label={"Note for Consultants"}
                      value={inputdata?.note || ''}
                      onChange={(i) => {
                        setinputdata((prev) => ({ ...prev, note: i.target.value }));
                      }}
                      placeholder={"Add any instructions or context for the bidders"}
                    />
                  </div>

                  <div className="mt-6 flex justify-end">
                    <button
                      type="button"
                      onClick={submit_therapy}
                      disabled={isProcessing}
                      className="rounded-xl bg-sky-600 px-6 py-2 text-sm font-semibold text-white shadow-sm shadow-sky-600/30 transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-60"
                    >
                      {isProcessing ? 'Please wait...' : 'Open for Bidding'}
                    </button>
                  </div>
                </div>
              </section>
            )}
          </div>
        ) : (
          <CustomSpinner />
        )}
      </div>
    </RightWrapper>
  );
};

export default AlternativeTherapies;
